<template>
  <div>
    <div>
      <b-card
        no-body
        class="border-0"
        style="min-width: 300px; max-width: 400px; min-height: 600px; max-height: 800px; border-radius: 55px 55px 90px 90px;"
      >
        <img
          class="img-responsive img-fluid position-absolute top-0"
          src="@/assets/img/mockups/smartphone-mockup.png"
          width="400px"
          :style="phone == true ? 'min-height: 650px; max-height: 650px;' : 'min-height: 850px; max-height: 850px;'"
        />
        <b-card-header
          :style="`${headerStyle}`"
          class="p-4 mt-2 smartphone-border-radius"
        >
          <b-row class="pa-2 px-3">
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-between mt-2"
              @click="alterarLogo()"
            >
              <b-button
                class="border-0"
                :variant="iconColor"
                @click="opened = true"
              >
                <i class="fas fa-bars" :style="`${iconStyle}`"></i>
              </b-button>
              <span class="editLogo">
                <i class="fas fa-edit"></i>
              </span>
              <b-img
                v-if="companyLogo"
                :src="`${getImagesAddressApp}${companyLogo}`"
                fluid
                width="70%"
                class="mt-4 mb-3 mr-3 cursor-pointer"
              ></b-img>
              <i class="fas fa-shopping-cart" :style="`${iconStyle}`"></i>
            </b-col>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-between"
            >
              <b-input placeholder="Buscar produto"></b-input>
              <i class="fas fa-search ml-2 mr-2" :style="`${iconStyle}`"></i>
              <i class="fas fa-camera ml-2" :style="`${iconStyle}`"></i>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-text class="p-4">
          <b-row>
            <b-col cols="12">
                <span class="editBanner"> <i class="fas fa-edit"></i> </span>
                <b-img
                  v-if="companyBanner"
                  :src="`${getImagesAddressApp}${companyBanner}`"
                  no-aspect
                  height="150px"
                  fluid
                  class="cursor-pointer"
                  @click="$router.push({ name: 'lojista-customizacoes-banners' })">
                </b-img>
                <b-skeleton v-else no-aspect height="100px" style="cursor: default;"></b-skeleton>
            </b-col>
            <!-- CATEGORIA 01 -->
            <b-col cols="12" class="mt-3 cursor-pointer" v-if="categoryFirstName != ''">
              <div class="font-weight-bold h4 mb-3" :style="fontStyle" @click="$router.push({ name: 'lojista-customizacoes-criar-categoria' })">
                {{ categoryFirstName }}
              </div>
              <span class="editCategoria" @click="$router.push({ name: 'lojista-customizacoes-criar-categoria' })"> <i class="fas fa-edit"></i> </span>
              <b-row>
                <b-col v-for="index in qtd" :key="index" @click="$router.push({ name: 'lojista-produtos-selecao' })">
                  <span class="imgProduto" v-show="index == 1"> <i class="fas fa-edit"></i> </span>
                  <img :src="`${getImagesAddressApp}produto.png`" class="itemProdutoFake" :alt="'Produto '+index">
                </b-col>
              </b-row>
            </b-col>
            
            <!-- CATEGORIA 02 -->
            <b-col cols="12" class="mt-3 cursor-pointer" v-if="categorySeccondName != ''">
              <div class="font-weight-bold h4 mb-3" :style="fontStyle" @click="$router.push({ name: 'lojista-customizacoes-criar-categoria' })">
                {{ categorySeccondName }}
              </div>
              <span class="editCategoria" @click="$router.push({ name: 'lojista-customizacoes-criar-categoria' })"> <i class="fas fa-edit"></i> </span>
              <b-row>
                <b-col v-for="index in qtd" :key="index" class="mb-3" @click="$router.push({ name: 'lojista-produtos-selecao' })">
                  <span class="imgProduto" v-show="index == 1"> <i class="fas fa-edit"></i> </span>
                  <img :src="`${getImagesAddressApp}produto.png`" class="itemProdutoFake" :alt="'Produto '+index">
                </b-col>
              </b-row>
            </b-col>

              <!-- CATEGORIA 03 -->
                <b-col cols="12" class="mt-1 cursor-pointer" v-if="categoryThirdName != '' && phone == false">
                  <div class="font-weight-bold h4 mb-3" :style="fontStyle" @click="$router.push({ name: 'lojista-customizacoes-criar-categoria' })">
                    {{ categoryThirdName }}
                  </div>
                  <span class="editCategoria" @click="$router.push({ name: 'lojista-customizacoes-criar-categoria' })"> <i class="fas fa-edit"></i> </span>
                  <b-row>
                    <b-col v-for="index in 3" :key="index" @click="$router.push({ name: 'lojista-produtos-selecao' })">
                      <span class="imgProduto" v-show="index == 1"> <i class="fas fa-edit"></i> </span>
                      <img :src="`${getImagesAddressApp}produto.png`" class="itemProdutoFake" :alt="'Produto '+index">
                    </b-col>
                  </b-row>
                </b-col>

          </b-row>
        </b-card-text>

        <b-sidebar
          v-if="opened"
          id="fake-app-menu"
          key="fake-app-menu"
          class="fake-app-menu sidebar-body-app"
          no-header
          v-model="opened"
        >
          <b-row class="px-3 py-2" :style="`${headerStyle}`">
            <b-col cols="3">
              <i class="fas fa-user-circle" style="font-size: 64px"></i>
            </b-col>
            <b-col cols="7" class="fs-18 my-auto">
              <span :style="fontStyle">Faça seu login ou se cadastre</span>
            </b-col>
            <b-col cols="2">
              <i
                class="fas fa-times fs-18 c-pointer"
                :style="`${iconStyle}`"
                @click="opened = false"
              ></i>
            </b-col>
            <b-col cols="12" class="mt-4 mb-2">
              <b-button class="w-100" variant="outline-secondary">
                <i
                  class="fas fa-arrow-circle-right mr-2"
                  :style="`${iconStyle}`"
                ></i>
                <span :style="fontStyle">Login</span>
              </b-button>
            </b-col>
            <hr />
          </b-row>
          <b-row class="mx-1 mt-2 fs-18">
            <b-col cols="12" class="mb-2">
              <i class="fas fa-home mr-2" :style="`${fontStyle}`"></i>
              <span :style="fontStyle">Início</span>
            </b-col>
            <b-col cols="12" class="mb-2">
              <i class="fas fa-envelope-open mr-2" :style="`${fontStyle}`"></i>
              <span :style="fontStyle">Contato</span>
            </b-col>
            <b-col cols="12">
              <i
                class="fas fa-question-circle mr-2"
                :style="`${fontStyle}`"
              ></i>
              <span :style="fontStyle">Ajuda</span>
            </b-col>
          </b-row>
        </b-sidebar>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'FakeApp',
  props: {
    headerMenuColor: {
      type: String,
      required: false,
      default: 'white',
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    fontColor: {
      type: String,
      required: false,
      default: 'black',
    },
    atualizar: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
    },
    logoApp: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
    iconStyle() {
      return `color: ${this.iconColor};`;
    },
    fontStyle() {
      return `color: ${this.fontColor};`;
    },
    backgroundStyle() {
      return `background-color: ${this.backgroundColor};`;
    },
    headerStyle() {
      return `background-color: ${this.headerMenuColor};`;
    },
  },
  watch: {
    opened(newValue) {
      if (!newValue) return;

      setTimeout(() => {
        this.addMenuBackgroundColor();
      }, 10);
    },
    backgroundColor() {
      this.addAppBackgroundColor();
      this.addMenuBackgroundColor();
    },
    'logoApp': function() {
      if(this.logoApp != '' && this.logoApp != null) {
        this.companyLogo = this.logoApp;
      }
    },
    atualizar() {
      this.categoryCompany();
    }
  },
  data() {
    return {
      opened: false,
      phone: false,
      qtd: 3,
      companyLogo: '',
      companyBanner: '',
      categoryFirstName: '',
      categorySeccondName: '',
      categoryThirdName: '',
      categorias: [],
      isGet: true,
    };
  },
  mounted() {
    var larguraDaTela = window.innerWidth;
    if(larguraDaTela < 700) {
      this.phone = true;
      this.qtd = 2;
    }

    this.getCompanyLogo();
    this.addMenuBackgroundColor();
    this.addAppBackgroundColor();
    this.getCompanyBanner();
    // this.categoryCompany();
    this.isGet == true ? this.get() : this.categoryCompany();
  },
  methods: {
    ...mapActions('shopkeeper', ['getAboutCompany', 'listBanner', 'getMenusApp']),
    addMenuBackgroundColor() {
      const menuBackground =
        document.getElementsByClassName('sidebar-body-app')[0];

      if (!menuBackground) return;

      menuBackground.style.backgroundColor = this.backgroundColor;
    },

    get() {
      this.$store.dispatch('startLoader');
      this.getMenusApp(this.userTypeId())
        .then((response) => {
          const data = response.data.data;

          if(data.length == 0) {
            this.ordem = 1;
            return;
          }

          let orders = [];
          this.items = [];
          this.itemsInactive = [];

          data.forEach(element => {
              let index = 0;
            if(element.status == 1) {
              this.itemsInactive.push(element);
              this.itemsInactive[index].order = null;
              index++;
            } else {
              this.items.push(element);
              orders.push(element.order)
            }
          });

          this.ordemButton = Math.max(...orders) + 1;
          if(this.orderButtom > 0) {
            this.ordem = this.itemsInactive.length += this.ordemButton;
          } else {
            this.ordem = this.ordemButton;
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as categorias!',
            'danger'
          );
        })
        .finally(() => {
          this.atualizar = !this.atualizar;
          this.$store.dispatch('endLoader');
        });
    },
    alterarLogo() {
      this.$emit('alterar-logo-fake');
    },
    addAppBackgroundColor() {
      const appBackground = document.getElementsByClassName('card')[0];

      if (!appBackground) return;

      appBackground.style.backgroundColor = this.backgroundColor;
    },
    async getCompanyLogo() {
      this.getAboutCompany(this.userTypeId())
        .then((response) => {
          const { logo } = response.data.data || {};
          this.companyLogo = logo || 'logo.png';
        })
        .catch(() => {})
        .finally(() => {});
    },

    getCompanyBanner() {
      this.listBanner(this.userTypeId())
        .then((response) => {
          const { image } = response.data.data[0] || {};
          this.companyBanner = image || 'banner.png';
        })
        .catch(() => {})
        .finally(() => {});
    },

    categoryCompany() {
      this.categorias = [];

      if(this.items == undefined) {
        this.categoryFirstName = 'Categoria 1';
        this.categorySeccondName = 'Categoria 2';
        this.categoryThirdName = 'Categoria 3';
        return;
      }

      this.items.forEach(element => {
        if(element.status == 0) {
          this.categorias.push(element)
        }
      });
      const { name } = this.categorias[0] || {};
      this.categoryFirstName = name || '';
      
      const nameCategory  = this.categorias[1].name || {};
      this.categorySeccondName = nameCategory || '';

      const nameCategoryThird  = this.categorias[2].name || {};
      this.categoryThirdName = nameCategoryThird || '';      
  },
  userTypeId(){
    return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
  },
  },
};
</script>

<style scoped>
body {
  padding: 1rem;
}
.itemProdutoFake {
  height: 90px;
  padding: 0;
  margin: 0;
}
.editLogo {
  position: absolute;
  right: 120px;
  top: 10px;
  cursor: pointer;
  color: #3d3dff;
}
.editBanner {
  position: absolute;
  right: 20px;
  top: -25px;
  cursor: pointer;
  color: #3d3dff;
}
.imgProduto {
  position: absolute;
  right: 0;
  top: -6px;
  cursor: pointer;
  color: #3d3dff;
}
.editCategoria {
  position: absolute;
  left: 15px;
  top: -18px;
  cursor: pointer;
  color: #3d3dff;
}

>>> .bg-light {
  background-color: transparent !important;
}

.fake-app-menu {
  width: 70%;
  margin-left: 19px;
  margin-top: 50px;
}

>>> .fake-app-menu.b-sidebar-outer {
  position: absolute !important;
  height: 90.1% !important;
}

>>> .fake-app-menu .b-sidebar {
  position: absolute !important;
  height: 100% !important;
}

>>> .b-sidebar > .b-sidebar-body {
  overflow: hidden;
  border-radius: 8px 0 0px 30px;
}

.smartphone-border-radius {
  border-radius: 85px 85px 0 0;
}
@media screen and (max-width: 700px) {
  .editLogo {
    right: 35%;
    top: 10px;
  }
  .itemProdutoFake {
    width: 90%;
  }
  .imgProduto {
    right: 0;
    top: -6px;
  }
}
</style>